import { Link } from 'react-router-dom';
import { ROLE_LABELS, VIEWS } from '@ouradent/shared';
import { useSession } from '../auth/SessionProvider';
import { Icon, type IconName } from '../ui/icons';
import { CloseX, DrawerShell, useDrawer } from '../ui/kit';
import { AutomationDrawer } from '../views/automations/AutomationDrawer';
import { ImportDrawer } from '../views/coldcall/Drawers';
import { CallDrawer } from '../views/calls/CallDrawer';
import { NewCallDrawer } from '../views/calls/NewCallDrawer';
import { EventDrawer } from '../views/calendar/EventDrawer';
import { LeadDrawer } from '../views/lead/LeadDrawer';
import { NewLeadDrawer } from '../views/lead/NewLeadDrawer';
import { SearchDrawer } from '../views/SearchDrawer';
import { FixDrawer } from '../views/Integrations';
import { NotificationsDrawer } from '../views/NotificationsDrawer';
import { InviteDrawer } from '../views/Team';
import { ClientsDrawer } from '../views/tasks/ClientsDrawer';
import { TaskDrawer } from '../views/tasks/TaskDrawer';

export function DrawerHost() {
  const { drawer } = useDrawer();
  return (
    <DrawerShell>
      {drawer?.type === 'lead' && <LeadDrawer key={drawer.id} id={drawer.id} />}
      {drawer?.type === 'newLead' && <NewLeadDrawer fromCall={drawer.fromCall} />}
      {drawer?.type === 'search' && <SearchDrawer />}
      {drawer?.type === 'menu' && <MenuDrawer />}
      {drawer?.type === 'call' && <CallDrawer key={drawer.id} id={drawer.id} />}
      {drawer?.type === 'newCall' && <NewCallDrawer />}
      {drawer?.type === 'invite' && <InviteDrawer />}
      {drawer?.type === 'task' && (
        <TaskDrawer
          key={drawer.id ?? `new-${drawer.clientId ?? ''}`}
          id={drawer.id}
          clientId={drawer.clientId}
        />
      )}
      {drawer?.type === 'clients' && <ClientsDrawer />}
      {drawer?.type === 'event' && (
        <EventDrawer
          key={drawer.id ?? `new-${drawer.start ?? ''}-${drawer.leadId ?? ''}`}
          id={drawer.id}
          start={drawer.start}
          leadId={drawer.leadId}
        />
      )}
      {drawer?.type === 'notifications' && <NotificationsDrawer />}
      {drawer?.type === 'auto' && <AutomationDrawer key={drawer.key} autoKey={drawer.key} />}
      {drawer?.type === 'callImport' && <ImportDrawer />}
      {drawer?.type === 'fix' && <FixDrawer key={drawer.provider} provider={drawer.provider} />}
    </DrawerShell>
  );
}

function MenuDrawer() {
  const { me, can, signOut } = useSession();
  const { open, close } = useDrawer();
  if (!me) return null;
  return (
    <>
      <div className="dhead">
        <div>
          <h2 id="dtitle">Menu</h2>
          <div className="sm">
            {me.fullName}, {ROLE_LABELS[me.role]}
          </div>
        </div>
        <CloseX />
      </div>
      <div className="dbody">
        <div className="mnav">
          <button onClick={() => open({ type: 'notifications' })}>
            <Icon name="bell" />
            Notifications
          </button>
          {can('pipeline') && (
            <button onClick={() => open({ type: 'search' })}>
              <Icon name="search" />
              Search leads
            </button>
          )}
          {VIEWS.filter((v) => can(v.perm)).map((v) => (
            <Link key={v.id} to={`/${v.id}`} onClick={close}>
              <Icon name={v.id as IconName} />
              {v.id === 'coldcall' && me.role === 'caller' ? 'My call queue' : v.label}
            </Link>
          ))}
        </div>
        <p style={{ marginTop: 18 }}>
          <button className="btn ghost" onClick={() => void signOut()}>
            Sign out
          </button>
        </p>
      </div>
    </>
  );
}
